import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { useMemo } from 'react';
import { Provider } from 'react-redux';
import { useIncaForm } from '../../hooks/useInca';
import { createValidator as defaultCreateValidator, ValidatorContext } from '../ValidatorContext';
import { ScopedData } from './ScopedData';
export const ScopedDesignedForm = (props)=>{
    const { createStore, createValidator, children } = props;
    const inca = useIncaForm();
    const createStoreRef = useRef(createStore);
    const store = useMemo(()=>{
        return createStoreRef.current({
            inca
        });
    }, [
        inca
    ]);
    const validator = useMemo(()=>{
        return createValidator ? createValidator({
            inca
        }) : defaultCreateValidator(inca.patient);
    }, [
        inca,
        createValidator
    ]);
    return /*#__PURE__*/ _jsx(Provider, {
        store: store,
        children: /*#__PURE__*/ _jsx(ValidatorContext.Provider, {
            value: validator,
            children: /*#__PURE__*/ _jsx(ScopedData, {
                children: (data)=>children(data)
            })
        })
    });
};
